<div class="topHead">
    <h2>Settings</h2>
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<br>
<!-- Default switch -->
<div class="centerWrap">
<div class="pageTitleBox">
    <h2>Settings</h2> 
</div>
<div class="row">
    <div class="col-sm-6">
        <form [formGroup]="settingForm">
        <div class="card">
            <ul class="list-group list-group-flush">
                <li class="list-group-item">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" formControlName="acccountValidity" [ngModel]="isCheckeds"  [checked]="false" class="custom-control-input" id="customSwitches" (change)="onChange($event)">
                        <label class="custom-control-label" for="customSwitches">Account Validity</label>
                    </div>
                </li>
                <li class="list-group-item">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" formControlName="loginMultipal" class="custom-control-input" id="customSwitches2" (change)="onChange($event)">
                        <label class="custom-control-label" for="customSwitches2">Multiple Logins</label>
                    </div>
                </li>
            </ul>
        </div>
        </form>
    </div>
</div>
</div>


